import moment from 'moment'
import Loader from '../../../../Global/Spinner'

const ActivityTimeline = ({ timeline, loading, hideButton }) => (
  <div className="row px-2 pb-3">
    <div className="col-12 card-activity-container">
      <div className="activity-header">
        <h6>Actividad reciente</h6>
        {!hideButton && (<button className='btn btn-migrates'>Ver todo</button>)}
      </div>
      {loading ? (
        <Loader size="2rem" />
      ) : timeline.length === 0 ? (
        <div className="alert alert-default-warning">
          Por el momento no hay informacion
        </div>
      ) : (
        timeline.map((item, index) => (
          <div className="activity-item" key={index}>
            <div className="item-icon">
              <i className="fas fa-id-badge iconColor1" />
            </div>
            <div className="item-details">
              <span className="details-title">
                {item?.TimelineToReports?.folio ||
                  item?.TimelineToReports?.folio}
              </span>
              <span className="details-status">
                Estatus: {item?.StatusOfTimeline?.name}
              </span>
            </div>
            <span className="item-time">
              {item?.date_status
                ? moment(item.date_status).format('dddd D[,] MMMM YYYY')
                : ''}
            </span>
          </div>
        ))
      )}
    </div>
  </div>
)

export default ActivityTimeline
